/**
 * Created by rcabr on 4/18/2016.
 */


angular.module('eStories.cms.model', [
    
    
])

